import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ModalVideo from 'react-modal-video';
import { useIntl } from 'react-intl';

const WatchLink = ({ className, videoId, text }) => {
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      window.$('.main-container .main-content').addClass('top');
    } else {
      window.$('.main-container .main-content').removeClass('top');
    }
  }, [isOpen]);

  return (
    <div className={className}>
      <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId={videoId}
        onClose={() => setIsOpen(false)}
      />

      <a
        href={`#${videoId}`}
        className="text-success"
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(true);
        }}
      >
        <i className="far fa-circle-play mr-1" />
        {text ? (
          <>{text}</>
        ) : (
          intl.formatMessage({ defaultMessage: 'Watch how' })
        )}
      </a>
    </div>
  );
};

WatchLink.propTypes = {
  className: PropTypes.string,
  videoId: PropTypes.string.isRequired,
  text: PropTypes.string,
};

WatchLink.defaultProps = {
  className: 'mt-4',
  text: null,
};

export default WatchLink;
